import React, { FunctionComponent, useEffect, useState } from 'react';
import { Row, Col, Spinner, Modal, } from 'react-bootstrap';
import { Link, Redirect, Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import icn_docker from '../../../assets/img/ui_icons/docker.svg'
import "./LicensesAnddownloads.css"
import "./../NewDashboard.css"

import icono_download from "../../../assets/img/newDashboard/icono_download.png";

import logo_AVAP from "../../../assets/img/newDashboard/logo_AVAP.png";
import logo_AVAP_DS from "../../../assets/img/newDashboard/logo_AVAP_DS.png";
import logo_AVAP_VS from "../../../assets/img/newDashboard/logo_AVAP_VS.png";
import logo_Gateway from "../../../assets/img/newDashboard/logo_Gateway.png";
import logo_Microsoft from "../../../assets/img/microsoft.png";
import logo_AVAP_Cli from "../../../assets/img/newDashboard/avapcli.png";


import logo_lang from '../../../assets/img/logos/AVAP_Lenguaje_white.svg'
import logo_vs from '../../../assets/img/logos/AVAP_VS_white.svg'
import logo_gateway from '../../../assets/img/logos/AVAP_Gateway_white.svg'

import logo_lang_dk from '../../../assets/img/logos/AVAP_Lenguaje.svg'
import logo_vs_dk from '../../../assets/img/logos/AVAP_VS.svg'
import logo_gateway_dk from '../../../assets/img/logos/AVAP_Gateway.svg'


import link_icon from "../../../assets/img/link-icon.png";

import logotipo_collaborativeN from "../../../assets/img/newDashboard/logotipo-collaborativeN.png";
import logo_AVAP_Cloud from "../../../assets/img/newDashboard/logo_AVAP_Cloud.png";
import ObexRequestHandler from '../../../handlers/ObexRequestsHandler';
import PaymentConfirmation from '../../../components/Modals/paymentConfirmation';
import AddCreditCard from '../../../components/Modals/addCreditCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faFile, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { faApple } from '@fortawesome/free-brands-svg-icons';
import icn_developerTk from "../../../assets/img/logos/icn_AVAP_DeveloperToolKit.svg";
import logo_AVAP_Toolkt from "../../../assets/img/logos/icn_AVAP_DeveloperToolKit.svg";
const TOOLKIT_BASE_URL = 'https://static.avapframework.com/static_images/downloads/staging/tk'; 

const developerToolkitProduct = {
  id: "avap_developer_toolkit", 
  name: "AVAP Developer Toolkit",
  icon: icn_developerTk,
  description: "AVAP Developer Toolkit is a comprehensive suite of tools and resources designed to enhance the development experience within the AVAP ecosystem.",
  price: 0, 
  platforms: { 
      "Windows": { "download_link": `${TOOLKIT_BASE_URL}/windows/windows-avap_developer_toolkit.zip` },
      "macOS Intel": { "download_link": `${TOOLKIT_BASE_URL}/macos_intel/macos_intel-avap_developer_toolkit.zip` },
      "macOS ARM64": { "download_link": `${TOOLKIT_BASE_URL}/macos_arm64/macos_arm64-avap_developer_toolkit.zip` },
      "Linux": { "download_link": `${TOOLKIT_BASE_URL}/linux/linux-avap_developer_toolkit.zip` }
  }
};

const PRODUCTS = ['AVAP-Language-Server-Kubernete-Deployment.yaml', 'vscode_extensions.zip', 'AVAP_DEV_Studio.zip', 'AVAP-Virtual-Server-Kubernete-Deployment.yaml', 'AVAP-Gateway-Advanced-Kubernete-Deployment.yaml', 'AVAP_DEV_Studio.zip', 
  'vscode_extensions.zip', '', '', '', 'avapcli.zip']


  const handleToolkitDownload = () => {
    const selectElement = document.getElementById("platform-select-toolkit") as HTMLSelectElement;
    if (selectElement) {
        const selectedPlatformKey = selectElement.value; 
        const platformData = developerToolkitProduct.platforms[selectedPlatformKey];
        if (platformData && platformData.download_link) {
            const link = document.createElement('a');
            link.href = platformData.download_link;
            link.click();
        } else {
            console.error("Download link not found for selected platform:", selectedPlatformKey);
        }
    }
};

  const LicensesAnddownloads = () => {
  let { path, url } = useRouteMatch();
  const [licenseslist, setLicenseslist] = useState([]);
  const [divsLicenses, setDivsLicenses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [paymentEnable, setPaymentMode] = useState(true);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [show, setShow] = useState(false);

  const [buyTitle, setBuyTitle] = useState ('');
  const [buySubTitle, setBuySubTitle] = useState ('');
  const [buyDescription, setBuyDescription] = useState ('');
  const [buyAmmount, setBuyAmmount] = useState(0);
  const [card_id_stripe, setCardID] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [cards_, setCards] = useState([]);
  const [newadded_card, setAddedCard] = useState('');

  const [itemSelected, setItemSelected] = useState({})
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme === 'dark';
});

  function sortByKey(array, key) {
    return array.sort(function(a, b) {
        var x = a[key]; var y = b[key];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}





  const getCards = async () => {
    try {
      const result = (await ObexRequestHandler.get('/cards', {}, true)).data || {};
      const { defaultCard, cards } = result;
      const pmCards = [];
      if (cards) {
        for (const c of cards) {
          const isDefault = c.id === defaultCard;
          c.defaultCard = isDefault;
          isDefault ? pmCards.unshift(c) : pmCards.push(c);
          if(cards_.some(e => e.id == c.id)){
            //console.log('exists');
          }else{
            setAddedCard(c.id);
          }
        }
      }
      setCards(pmCards);
  
    } catch (error) {
      console.error('ERROR FETCHING CARDS ', error);
      throw error;
    }
  }

  const handleModal = () => {
    setShowModal(!showModal);
    //onCloseAction();
    getCards();

  };
  

  const handleCard = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { value } = e.target;
    if (value=='addCard') {
      handleModal();
    } else {
      setCardID(value);

    }
    console.log(value);
    e.preventDefault();
    e.stopPropagation();
  
  }

  const startPayment = () => {
    setLoading(true);
    setSuccess('');
    setError('');
  }

  const onCloseAction = () =>{

    setShow(false)
  }

  const OnSuccesAction = () =>{
    
    setShow(false)
    if (!error) {
      history.push('/dashboard');
      history.push('/dashboard/licenses-and-suscriptions');
    }
    setShow(false);
  }


  const dockerCommands = [
    {
        title: 'AVAP Language',
        logo: isDarkMode ? logo_lang_dk: logo_lang,
        command: 'docker pull avapframework/avap-language-server:latest',
        doc_path: 'https://developer.avapframework.com/wiki/#avap_language_server_docker_doc'
    },
    {
        title: 'AVAP Virtual Server',
        logo: isDarkMode ? logo_vs_dk: logo_vs,
        command: 'docker pull avapframework/avap-virtual-server:latest',
        doc_path: 'https://developer.avapframework.com/wiki/#avap_virtual_server_docker_doc'
    },
    {
        title: 'AVAP Gateway',
        logo: isDarkMode ? logo_gateway_dk: logo_gateway, 
        command: 'docker pull avapframework/avap-gateway-advanced:latest',
        doc_path: 'https://developer.avapframework.com/wiki/#avap_gateway_advanced_docker_doc'
    }
];


  const [copiedCommandIndex, setCopiedCommandIndex] = React.useState<number | null>(null);
  const handleCopyCommand = (command: string, index: number) => {
    navigator.clipboard.writeText(command).then(() => {
        setCopiedCommandIndex(index); // Indicate which command was copied
        setTimeout(() => setCopiedCommandIndex(null), 2000); // Reset after 2 seconds
    }).catch(err => {
        console.error('Failed to copy command: ', err);
        // Optionally show an error message to the user
    });
};

  const makePayment = async () => {
    try {
      startPayment();
      sendBuy(itemSelected)
      /*
      const payload = {};
      const result = await ObexRequestHandler.post('/signup_avapcloud', payload);
      const { success, message, data } = result;
      if (!success) throw { message };
      setSuccess(data);
      setPaymentSuccess(true);
      setPaymentMode(false);
      OnSuccesAction();
      /*setTimeout(() => {
        onSuccess();
      }, 5000);*/ // TODO MIRAR SI HABILITAR ESTO
      
    } catch (error) {
      setError(error.message || error);
      console.error('ERROR BUYING EXTRA PROJECTS SLOTS ', error);
    }
    setLoading(false);
    
  }

  const history = useHistory();

  const OpenBuy = (item) => {
    console.log(item)
    setItemSelected(item);
    setBuyAmmount(item.price)
    setBuyTitle(`Buy ${item.name}`)
    setBuySubTitle('Please confirm your buy and proceed to pay.')
    setBuyDescription(item.name);
    setShow(true);

  }

  const logos =
    [
      {
        "id": 1,
        "name": "AVAP Interpreter & Language Server",
        "img": logo_AVAP
      },
      {
        "id": 2,
        "name": "AVAP Dev Extensions for Microsoft Visual Code",
        "img": logo_AVAP_DS,
      },
      {
        "id": 3,
        "name": "AVAP Dev Studio",
        "img": logo_AVAP_DS,
      },
      {
        "id": 4,
        "name": "AVAP Virtual Server Enterprise",
        "img": logo_AVAP_VS,
      },
      {
        "id": 5,
        "name": "AVAP Gateway Advanced",
        "img": logo_Gateway,
      },
      {
        "id": 6,
        "name": "AVAP Collaborative Network",
        "img": logotipo_collaborativeN,
      },
      {
        "id": 7,
        "name": "AVAP Cloud Business",
        "img": logo_AVAP_Cloud,
      },
      {
        "id": 8,
        "name": "AVAP Cloud Enterprise",
        "img": logo_AVAP_Cloud,
      },
      {
        "id": 9,
        "name": "AVS",
        "img": logo_AVAP_VS,
      },
      {
        "id": 10,
        "name": "AVAP Gateway Advanced",
        "img": logo_Gateway,
      },
      {
        "id": 11,
        "name": "AVAP Cli",
        "img": logo_AVAP_Cli,
      },
      {
        "id": 15,
        "name": "AVAP AVAP Developer Toolkit",
        "img": logo_AVAP_Toolkt,
      }
    ];
    const [isBuying, setIsBuying] = useState(false);
  


const getIcon = (id: string)=>{

  const isDark =  localStorage.getItem('theme') == 'dark';

  if (id==='AVAP Language') return !isDark ? logo_lang_dk: logo_lang;
  if (id==='AVAP Virtual Server') return !isDark ? logo_vs_dk: logo_vs;
  if (id==='AVAP Gateway') return !isDark ? logo_gateway_dk: logo_gateway;

}

  useEffect(() => {

 

    getLicenses();
    getCards();
    window.scrollTo(0, 0);

  }, []);

  const getLicenses = async () => {
    try {
      const result = (await ObexRequestHandler.get('/get_all_licenses_availables')).data;
      generateItemLicenses(result);
      console.log(result)
    } catch (error) {
      console.error('ERROR GET PRIVACY INFO', error);
    }
  };

  const get_user_licenses = async () => {
    try {
      const result = (await ObexRequestHandler.get('/get_user_licenses')).data;
      return result;
    } catch (error) {
      console.error('get_user_licenses', error);
    }
  };


const sendDownload = async (item) => {
  if (item === 3) return;
console.log(item)

  let urlefe = undefined;
  const t = document.getElementById(item) as HTMLSelectElement;
  const plat = (t.options[Number(t.value)-1].text).toLowerCase().replace(' ', '_')
console.log(Number(item))

  if (Number(item) !== 2 && Number(item) !== 2 && Number(item) !== 5)  {

    
    console.log(t)
    

    console.log(plat);
    console.log(PRODUCTS[Number(item)-1]);

    urlefe = `https://static.avapframework.com/static_images/downloads/staging/${plat}/${PRODUCTS[Number(item)-1]}`;

  } else {

    urlefe = `https://static.avapframework.com/static_images/downloads/staging/${PRODUCTS[Number(item)-1]}`
    
  }

  if (item == 15) {

    console.log(item)
  urlefe = `https://static.avapframework.com/static_images/downloads/staging/${plat}/AVAP Developer Toolkit.zip`;

  }

  if (urlefe !== undefined){
    const link = document.createElement('a');
    link.target = '';
    link.href = urlefe;
    link.click();
  }

}

  const sendBuy = async (item) => {
    setIsBuying(true);
    try {
      // debugger
      
      console.log(item);
      const result = (await ObexRequestHandler.post('/buy_license', {license_id:item.id}));

      if(result.success){
        
        window.location.reload();
      }
      
      return result;
    } catch (error) {
      console.error('buy_license', error);
    } finally{
      setIsBuying(false);
    }

  }


  const generateItemLicenses = async (licenses) => {
        let arrayDivsProyects = [];

        let itemsBought = await get_user_licenses();
    
        let licOrdered = sortByKey(licenses, 'orden');

        for (const key in licOrdered) {
          let item = licenses[key];
          let imgFounded = logos.find(proj => proj.id === item.id);
          let itHasBeenBought =  itemsBought.find(itemBought => itemBought.id === item.id);
            let bought = itHasBeenBought ? true : false;

        if (licenses[key].obex_license_type_id!=2)
      arrayDivsProyects.push(

        <div className="boxShadowCard borderRadius " key={key}>
          <div className='py-3 d-flex flex-column'>
            {/* Header card */}
            <div ></div>
            <div className='d-flex boxShadowCardBottomTitle pl-3 pb-3'>
              <div className='pr-4'>
                <div className='sizeImgTitleCard'>
                  <img src={imgFounded.img} alt="" width={'100%'} height={'100%'} />
                </div>
              </div>
              <div className='fontSizeTitleCard textBold'>
                {licenses[key].name}

              </div>
            </div>

            {/* Header card END*/}

            {/* Content */}
            <div className='d-flex flex-column align-self-center widthContentCard pt-3'>
            <div className='d-flex flex-column cardSize'>
            <div className='colorBlack mb-3 txt-wrp'>
                  {licenses[key].description}
                </div>

            { licenses[key].obex_license_type_id != 2 ?

              (licenses[key].obex_license_type_id != 3 ?
                <div className={`${(licenses[key].name == 'AVAP CLI (Command Line Interface)' || licenses[key].name == 'AVAP Dev Studio' || licenses[key].name == 'AVAP Developer Toolkit')? 'select-container': 'select-container2'} d-flex mb-5`}>
                  <div className='backgroundSelect borderRadiusLeft d-flex align-items-center px-2'>Platform</div>
                  
                   {(licenses[key].obex_license_type_id == 1 && (licenses[key].name == 'AVAP CLI (Command Line Interface)' || licenses[key].name == 'AVAP Dev Studio' || licenses[key].name == 'AVAP Developer Toolkit')) ?
                  <select id ={licenses[key].id} className="form-select p-2 borderRadiusRight backgroundSelect colorBlack" aria-label="Default select example">
                    <option value="1">Windows</option>
                    <option value="2">macOS Intel</option>
                    <option value="3">macOS ARM64</option>
                    <option value="4">Linux</option> 
                    
                  </select> :
                  <select id = {licenses[key].id} className="form-select p-2 borderRadiusRight backgroundSelect colorBlack" aria-label="Default select example">
                    <option value="1">Kubernete deployment</option>                    
                  </select> 
                  }
                  { !(licenses[key].name == 'AVAP CLI (Command Line Interface)' || licenses[key].name == 'AVAP Dev Studio') &&
                  <div className='backgroundSelect borderRadiusLeft borderRadiusRight' style={{width:'50px', borderTopRightRadius:'10px', borderBottomRightRadius:'10px'}}>
                  
                  <FontAwesomeIcon
                                            icon={faFileAlt}
                                            className="copy-icon"
                                            onClick={ (e) => {
                                              e.preventDefault();
                                              const tab = window.open('', '_blank');

                                              let doclink = 'https://developer.avapframework.com/wiki/#avap_language_server_deployment_doc';
                                              
                                              if (licenses[key].id == 4) doclink = 'https://developer.avapframework.com/wiki/#avap_virtual_server_deployment_doc';
                                              if (licenses[key].id == 5) doclink = 'https://developer.avapframework.com/wiki/#avap_gateway_advanced_deployment_doc';

                                              if (licenses[key].id == 15) doclink = 'https://staging.avapcloud.com/wiki/#avap_library_creation_intro';

                                              tab.location.href =doclink; // URL aquí
                                              tab.focus();
                                          }}
                                            title={'Documentation'}
                                            style={{
                                                position: 'absolute',
                                                top: '30%',
                                                right: '12px',
                                                cursor: 'pointer',
                                            }}
                                        />

                  </div>
        }
                </div>
                :
                <div id={licenses[key].id} className="textBold link-container d-flex mb-5"><a style={{width:'100%', height:'40px', borderRadius: '12px', color:'black'}} className=" backgroundSelect borderRadiusLeft borderRadiusRight d-flex align-items-center px-2" href="https://marketplace.visualstudio.com/items?itemName=101OBeXCorp.avap-linter" target='_BLANK'><img style={{marginRight:'10px', color:'black'}} src={logo_Microsoft} alt="" width={"20px"} height={"20px"} /> <span className='res-text'>Microsoft Visual Studio Code Marketplace</span> </a></div>

              ):

                <></>





              }


                <div className='d-flex flex-row W-100 justify-content-between colorGreen textBold mb-3 fontText3'>
                  <div> {licenses[key].price>0 ? '':''}</div>
                  <div >{
                    licenses[key].price >= 0 ?
                    (
                  licenses[key].price === 0 ? '' : (bought ? '':'')
                    )
                  : 'Contact Us'
                  }
                  
                  </div>
                </div>

                <div className='d-flex flex-row W-100 justify-content-between'>
                  <div>
                    <div className='sizeImgTitleCard'>
                   {/*}   { licenses[key].price > 0 && licenses[key].obex_license_type_id!=2 ? <img src={icono_download} alt="" width={"100%"} height={"100%"} />: <></>} */}
                    </div>
                  </div>

                  { licenses[key].id === 6 ?
                  <div className='w-65'>
                    <button style={{ marginTop:'auto', padding:'3px 0px', marginLeft:'auto', marginRight:'auto' }} className="btn custom-button w-100 textBold" disabled={bought || isBuying} onClick={() => OpenBuy(item)}>{
                    licenses[key].price >= 0 && !bought ?
                    (licenses[key].price === 0 ? 
                      (
                        licenses[key].id === 6 ?
                        ' Go to AVAP Collaborative Network':
                        'Download'
    
    
                      )
                      
                      
                       : 'Buy Now'):
                    'Contact Us'
                    
                    }</button>
                  </div>
                  :
                  <div className='w-40'>
                    <button style={{ marginTop:'auto',padding:'3px 0px', marginLeft:'auto', marginRight:'auto' }} className="btn custom-button w-100 textBold" disabled={isBuying} onClick={() => {
                      if (bought || licenses[key].price === 0) sendDownload(licenses[key].id); else {
                        if (licenses[key].price === 0 || bought) sendDownload(licenses[key].id); else sendDownload(licenses[key].id) 
                      }
                    }}>{
                    licenses[key].price >= 0 ?
                    (licenses[key].price === 0 ? 
                      (
                        licenses[key].id === 6 ?
                        ' Go to AVAP Collaborative Network':
                        'Download'
                      )
                       : (bought ? 'Coming Soon':'Coming Soon')):
                    'Contact Us'
                    
                    }</button>
                  </div>
                  }
                </div>

              </div>
            </div>
            {/* Content END*/}






          </div>
        </div>








      )

    }

    setDivsLicenses(arrayDivsProyects);
    setIsLoading(false);
    // return arrayDivsProyects;

  }


  return (
    <><div>
      <h2 className='textBold marginBottom2rem'>Downloads</h2>
      <p className='fontText3 colorBlack marginBottom2rem'>Purchase and manage your AVAP products and services.</p>
      {isLoading &&
        <div className='d-flex justify-content-center align-items-center '>
          <Spinner animation="border" />
        </div>}
      <div className="grid-container" style={{ width:'65vw' }}>

        {divsLicenses}
      </div>






      <div className="container docker-section mt-5 mb-5">
                    <div className="row">
                        <div className="col-12 text-center mb-4 mt-5">
                           <img src={icn_docker} alt="Docker Logo" style={{ height: '150px', marginBottom: '15px' }}  />
                            <h2 className="fl-title">Start by downloading our official Docker images.</h2>
                            <p className="mt-3" style={{ maxWidth: '800px', margin: '0 auto' }}>
                                Deploy AVAP components quickly and consistently using our official Docker images.
                                Follow the instructions below to get started with AVAP Language, Virtual Server, or Gateway in your Docker environment.
                            </p>
                        </div>
                    </div>
                    <div className="row justify-content-center mt-5">
                        {dockerCommands.map((item, index) => (
                            <div key={index} className="col-md-10 col-lg-8 mb-4">
                                <div className="docker-command-card text-start">
                                    <img id={item.title} src={getIcon(item.title)} alt={item.title} className="docker-card-logo" style={{ height: '40px', marginBottom: '15px', }} />
                                    <div className="command-line-container" style={{ position: 'relative' }}>
                                        <pre><code><span style={{ marginRight:'8px', color:'green' }}>$</span>{item.command}</code></pre>
                                        <FontAwesomeIcon
                                            icon={faCopy}
                                            className="copy-icon"
                                            onClick={() => handleCopyCommand(item.command, index)}
                                            title={copiedCommandIndex === index ? 'Copied!' : 'Copy command'}
                                            style={{
                                                position: 'absolute',
                                                top: '55%',
                                                right: '10px',
                                                cursor: 'pointer',
                                                color: copiedCommandIndex === index ? 'var(--primary)' : 'lightgray'
                                            }}
                                        />


                                        <FontAwesomeIcon
                                            icon={faFileAlt}
                                            className="copy-icon"
                                            onClick={ (e) => {
                                              e.preventDefault();
                                              const tab = window.open('', '_blank');
                                              tab.location.href = item.doc_path; // URL aquí
                                              tab.focus();
                                          }}
                                            title={'Documentation'}
                                            style={{
                                                position: 'absolute',
                                                top: '55%',
                                                right: '35px',
                                                cursor: 'pointer',
                                                color: copiedCommandIndex === index ? 'var(--primary)' : 'lightgray'
                                            }}
                                        />


                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                



    </div><>{show &&

      <Modal dialogClassName="addons-dialog w-75 obex-dialog"
        show={show}
        onHide={onCloseAction}
        animation={false}
        container={document.getElementById('avapIdWrapper')}>
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="text-center w-100">
            <Row>
              <Col className="addons-title">
                <span>{buyTitle}</span>
              </Col>
            </Row>
            <Row>
              <Col md="10" className="mx-auto text-center modal-subtitle">
                <span className="text-center d-block">{buySubTitle}</span>
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PaymentConfirmation
            actionSubmit={makePayment}
            handleGoBack={() => {
              setPaymentMode(false),
                setShow(false);
            } }
            handleAnnualPayment={null}
            nameServiceSelected={buyDescription}
            amountMonth={buyAmmount}
            amountYear={(buyAmmount * 10) / 12}
            processingPayment={loading}
            success={success}
            error={error}
            handleCard={handleCard}
            isBlue={false}
            cards={cards_}
            prorated={true}
            addedCard={newadded_card}
            spanish={false}

            />
        </Modal.Body>
      </Modal>}
      {showModal && <AddCreditCard show={showModal} handleClose={handleModal} isGreen={true} spanish={false}/>}
      </></>



  );
}


export default LicensesAnddownloads;









